import { Toaster as SonnerToaster } from 'sonner';

interface ToastProps {
  position?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';
}

function Toaster({ position = 'bottom-right' }: ToastProps): React.ReactElement {
  return (
    <SonnerToaster
      position={position}
      toastOptions={{
        style: {
          background: 'var(--card)',
          color: 'var(--card-foreground)',
          border: '1px solid var(--border)',
        },
      }}
      theme="dark"
    />
  );
}

export { Toaster };
